import React from "react"
import Footer from "./Footer"
import Navbar from "./Navbar"
import "../styles/global.scss"
import { Helmet } from "react-helmet"
import { AnimatePresence, motion } from "framer-motion"
import { pageVariants } from "../animation/page.variants"

export default function Layout({ children }) {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Project Nenathambara</title>
      </Helmet>
      <Navbar />
      <AnimatePresence exitBeforeEnter>
        <motion.div
          className="content"
          variants={pageVariants}
          initial="init"
          animate="animate"
          exit="exit"
        >
          {children}
        </motion.div>
      </AnimatePresence>
      <Footer />
    </div>
  )
}
